// These constants affect the rarely deployed "gdpr" webpack bundle, keep them here in its own file separated from the more frequently changed files elsewhere in iron/common

/**
 * Since we load 3rd party script on mixpanel like visual weboptimizer and likes
 * They use localstorage for tracking related info
 * STORAGE_ALLOWLIST restricts what can be used in localStorage/sessionStorage when user is in GDPR mode.
 */
export const STORAGE_ALLOWLIST = [
  `dismissible-persistence-banner-key`,
  `sessionid`,
  `csrftoken`,
  `__mp_opt_in_out`,
  `mp_optout`,
  `mp_user`,

  // MRFE 112
  `_mkto_trk`,
  `mp__origin`,
  `mp__origin_referrer`,
  `mixpanel_utm_campaign`,
  `mixpanel_utm_content`,
  `mixpanel_utm_medium`,
  `mixpanel_utm_source`,
  `mixpanel_utm_term`,

  // from iron/common/report/constants.ts LocalStorageKey enum
  // we can't use const enums because webpack compiles with --isolatedModules
  `$mp_message_targeting_from_explore`,
  `$mp_features_cache`,
  `$mp_last_opened_dashboard`,
  `$mp_dark_mode`,
  // LocalStorageKey.Panel
  `$mp_panel`,
  `$mp_sidebar`,
  `$mp_sidenav`,
  `$mp_global_sidenav`,
  `$mp_current_project_client_cache`,
  `$mp_dismiss_tooltip_tour`,
  `$mp_onboarding_checklist`,
  `$mp_cross_project`,
  // LocalStorageKey.SearchedTextPersistedState
  `$mp_browse_search_text`,
  // LocalStorageKey.OrganizationId
  `$mp_org`,
  `$mp_onboarding_questionnaire_skips`,
  `$mp_onboarding_questionnaire_dismissed`,
  `$mp_metrics_beta_button`,
];
